import * as React from 'react'
import "./../Post.css"
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import {
  usePopupState,
  bindTrigger,
  bindMenu,
} from 'material-ui-popup-state/hooks'

const MenuPopupState = (props) => {
  const popupState = usePopupState({ variant: 'popover', popupId: 'demoMenu' })

  return (
    <div className="menuPopup">
      <MoreVertIcon
        className="menuPopup__trigger"
        {...bindTrigger(popupState)}
        aria-controls="fade-menu"
        aria-haspopup="true"
      />
      <Menu {...bindMenu(popupState)} elevation={4}>
        {props.editfunction && (
          <MenuItem
            onClick={() => {
              popupState.close()
              props.editfunction()
            }}
          >
            {props.editlabel}
          </MenuItem>
        )}

        {props.functiontopass && (
          <MenuItem
            onClick={() => {
              popupState.close()
              props.functiontopass(props.datatopass)
            }}
          >
            {props.labeltopass}
          </MenuItem>
        )}

        {props.topmenu && (
          props.user ? (
            <MenuItem
              onClick={() => {
                popupState.close()
                props.signout && props.signout()
              }}
            >
              {props.signoutlabel}
            </MenuItem>
          ) : (
            <div>
              <MenuItem
                onClick={() => {
                  popupState.close()
                  props.signin && props.signin()
                }}
              >
                {props.signinlabel}
              </MenuItem>
              <MenuItem
                onClick={() => {
                  popupState.close()
                  props.signup && props.signup()
                }}
              >
                {props.signuplabel}
              </MenuItem>
            </div>
          )
        )}

        {props.installapp && (
          <MenuItem
            onClick={() => {
              popupState.close()
              props.installapp()
            }}
          >
            {props.installapplabel}
          </MenuItem>
        )}

        <MenuItem onClick={popupState.close} className="menuPopup__cancel">
          <span>{props.lang ? "Annuler" : "Cancel"}</span>
        </MenuItem>
      </Menu>
    </div>
  )
}

export default MenuPopupState